import * as React from 'react';
import Head from 'next/head';

import { SITE_TITLE } from '@src/config/constants';
import { Mission } from '@src/routes/home/sustainability/components/Mission/Mission';
import { Philosophy } from '@src/routes/home/sustainability/components/Philosophy/Philosophy';
import { Practices } from '@src/routes/home/sustainability/components/Practices/Practices';

export interface SustainabilityProps {}

/**
 * @name Sustainability
 * @description Sustainability page
 */
export const Sustainability = (_props: SustainabilityProps) => {
  return (
    <>
      <Head>
        <title>{`Sustainability | ${SITE_TITLE}`}</title>
      </Head>

      <main>
        <Mission />
        <Philosophy />
        <Practices />
      </main>
    </>
  );
};

export default Sustainability;
